import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { CommonCd } from '../common-cd/CommonCd';
import { MedicalChoice } from '../medical-choice/MedicalChoice';

/**
 * # MedicalQuestion
 *
 * MedicalQuestion을 설명하세요.
 */
export const MedicalQuestion = types
  .model('MedicalQuestion')
  // --------------------------------------------------------------------------
  .props({
    medQstSid: types.number,
    medQst: types.string,
    medQstTypeCd: CommonCd,
    order: types.maybeNull(types.number),
    subjectiveYn: types.string,
    multiSelectYn: types.string,
    langCd: types.maybeNull(types.string),
    medicalQuestionChoiceList: types.array(MedicalChoice),
    subjectiveAnswer: types.string,
    subjectiveType: types.string,
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model medicalQuestion --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: Partial<IMedicalQuestionSnapshot>) => {
      const newProps = { ...self, ...props } as IMedicalQuestion;
      (Object.keys(newProps) as TMedicalQuestionKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TMedicalQuestion = Instance<typeof MedicalQuestion>;
type TMedicalQuestionSnapshot = SnapshotOut<typeof MedicalQuestion>;

export interface IMedicalQuestion extends TMedicalQuestion {}
export type TMedicalQuestionKeys = keyof TMedicalQuestionSnapshot & string;
export interface IMedicalQuestionSnapshot extends TMedicalQuestionSnapshot {}
export const createMedicalQuestion = () => types.optional(MedicalQuestion, {} as TMedicalQuestion);

export const MedicalQuestionResult = types.model('medicalQuestionResult', {
  medQstSid: types.number,
  medQstInputVal: types.string,
});
type TMedicalQuestionResult = Instance<typeof MedicalQuestionResult>;
export interface IMedicalQuestionResult extends TMedicalQuestionResult {}
export const createMedicalQuestionResult = () =>
  types.optional(MedicalQuestionResult, {} as TMedicalQuestionResult);
